export type AppErrorSeverity = 'info' | 'warning' | 'error';

export interface AppErrorInfo {
  severity?: AppErrorSeverity;
  title?: string;
  message?: string;
  rootCause?: Error;
}

/**
 * Represents a known error condition, with user-friendly title and message and configurable
 * severity. Default values are used if title/message/severity are not provided.
 */
export class AppError extends Error {
  severity: AppErrorSeverity;
  title: string;
  message: string;
  rootCause?: Error;

  constructor({ severity, title, message }: AppErrorInfo, rootCause?: unknown) {
    super(title ?? 'Something happened on our end');
    this.severity = severity ?? 'error';
    this.title = title ?? 'Something happened on our end';
    this.message = message ?? 'Try again and contact Chronosphere support if the issue persists';
    this.rootCause = rootCause as Error;
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
